const offerInputSchema = {
    properties: {
        amount: { type: "string" },
        merchantId: { type: "string" },
        pcgc: { type: "string" }
    },
};

export default offerInputSchema;